import { AriaRoles } from '@heidi-pay/heidi-common-fe/enums';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { useI18n } from '@hooks/useI18n';
import { StatusIconType } from './enums';
import { getStatusIcon } from './getStatusIcon';

interface IIconWrapper {
  color: string;
}

const IconWrapper = styled('div')(({ color }: IIconWrapper) => ({
  display: 'flex',
  alignItems: 'center',
  color,
}));

interface IStatusIconProps {
  className?: string;
  tooltip?: string;
  type: StatusIconType;
}

export const StatusIcon = ({ className, tooltip, type }: IStatusIconProps) => {
  const { translate } = useI18n();
  const { color, icon: Icon } = getStatusIcon(type);

  const content = (
    <IconWrapper className={className} color={color}>
      <Icon
        aria-hidden={false}
        aria-label={type}
        fontSize="small"
        role={AriaRoles.Img}
      />
    </IconWrapper>
  );

  return tooltip ? (
    <Tooltip className={className} title={translate(tooltip)}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};
